"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.webPostEventRequest = void 0;
const typebox_1 = require("@sinclair/typebox");
const optional_null_or_string_1 = require("../../optional-null-or-string");
const web_core_event_1 = require("./web-core-event");
const WebPageViewEvent = typebox_1.Type.Object({
    deprecated_browser: typebox_1.Type.Optional(typebox_1.Type.Boolean()),
    referrer: typebox_1.Type.Optional(typebox_1.Type.String()),
    utm_source: optional_null_or_string_1.OptionalNullOrString,
    utm_medium: optional_null_or_string_1.OptionalNullOrString,
    utm_campaign: optional_null_or_string_1.OptionalNullOrString,
});
const WebExtraParams = typebox_1.Type.Composite([
    typebox_1.Type.Object({
        resource_version: typebox_1.Type.Optional(typebox_1.Type.Union([typebox_1.Type.String(), typebox_1.Type.Object({})])),
    }),
    WebPageViewEvent,
    typebox_1.Type.Unknown(), // Custom Data (not sure if we have to 'allow' it through?)
]);
// TODO bring in the types from https://github.com/checkatrade/core-libs-analytics-frontend
exports.webPostEventRequest = typebox_1.Type.Composite([
    web_core_event_1.WebCoreEvent,
    typebox_1.Type.Object({
        page_url: typebox_1.Type.String(),
        product_language: typebox_1.Type.String(),
        browser_width: typebox_1.Type.Number(),
        browser_height: typebox_1.Type.Number(),
        extra_params: typebox_1.Type.Optional(WebExtraParams),
        os_language: typebox_1.Type.String(),
    }),
], {
    description: 'Structured analytics event',
    examples: [
        {
            app_version: 'some:app:version',
            browser_height: 681,
            browser_width: 1720,
            device_id: 'bf70b1dd-f308-4540-8d3e-b0c223c8c9af',
            environment: 'development',
            event_name: 'homepage.show',
            extra_params: {
                resource_type: 'homepage',
                resource_version: { success_page: 1, ranking_algorithms: 23 },
            },
            os_language: 'en-GB',
            page_url: '/',
            product_language: 'en-GB',
            session: 'c92a6c26-459b-40c5-9676-808c80b44099',
            ts: '2024-08-29T12:20:21.515Z',
            ts_local: '2024-08-29T13:20:21.000Z',
            user_id: null,
        },
    ],
});
//# sourceMappingURL=web-post-event-request.js.map